import { Link, useNavigate } from 'react-router-dom'
import Header from '../../components/Header'
import Page from '../../components/Page'
import { useCreateFonte } from '../../hooks/fonti'
import FonteForm from '../../components/FonteForm'

export default function FonteCreate() {
  const createFonte = useCreateFonte()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/fonti">Fonti</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Aggiungi
            </li>
          </ol>
        </nav>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <FonteForm
          save={async (fonte) => {
            const newFonte = await createFonte.mutateAsync(fonte)
            navigate(`/fonti/${newFonte.id}`)
          }}
        />
      </div>
    </Page>
  )
}
